import React from 'react'
import "./contactTeam.scss";
import { Link } from 'react-router-dom';

const ContactTeam = () => {
  return (
    <div className="contact_wrp">
      <span>
        Have questions or need expert guidance? <br />{" "}
        <em>Our team is here to help you every step of the way.</em>
      </span>
      <Link to={'/contact'} >
        <button className="btn">Contact Team</button>
      </Link>
    </div>
  );
}

export default ContactTeam
